import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import FullUser from "../fragments/fullUserV4"

const mutation = gql`
  mutation UpdateUsersByEmail($users: [UpdateUserByEmailInput]!, $tenantId: String!) {
    updateUsersByEmail(users: $users, tenantId: $tenantId) {
      ...fullUser
    }
  }
  ${FullUser}
`

export const updateUsersByEmailKey = getQueryNames(mutation)[0]

export default mutation
